import { t } from './index.ts';

/** Textos fuente declarados en mapas de etiquetas; la prueba de catálogos verifica que todos estén traducidos. */
export const declaredKeys = new Set<string>();

/**
 * Mapa de etiquetas que se traduce al leerlo: `EVENT_LABEL.birth` devuelve "Nacimiento", "Birth"…
 * según el idioma activo. Las claves siguen siendo enumerables (`Object.keys` funciona igual).
 */
export function labels<K extends string>(source: Record<K, string>): Readonly<Record<K, string>> {
  const out = {} as Record<K, string>;
  for (const k of Object.keys(source) as K[]) {
    declaredKeys.add(source[k]);
    Object.defineProperty(out, k, { enumerable: true, get: () => t(source[k]) });
  }
  return out;
}

/** Declara un texto fuente usado fuera de `t('…')` literal (p. ej., pasado por variable). Devuelve el mismo texto. */
export function msg(source: string): string {
  declaredKeys.add(source);
  return source;
}
